import React from "react";
import { Link } from "react-router-dom";
import { global } from "../../App/routes";

export default function ExpInfo(props) {
  return (
    <section className="exp-info">
      <div className="container-fluid m-0 p-0">
        <div className="row m-0 p-0">
          <div className="col-12 col-md-6 m-0 p-0">
            <div className="info-holder gift d-flex justify-content-center align-items-center flex-column">
              <div className="icon d-flex align-items-center">
                <svg
                  width="82"
                  height="77"
                  viewBox="0 0 82 77"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M76.875 20.4608H60.6595C61.8229 19.6641 62.8223 18.8725 63.5192 18.1632C67.6551 13.9947 67.6551 7.21004 63.5192 3.04155C59.5012 -1.01899 52.5005 -1.00871 48.4876 3.04155C46.2634 5.27742 40.3696 14.3802 41.1845 20.4608H40.8155C41.6252 14.3802 35.7315 5.27742 33.5124 3.04155C29.4944 -1.00871 22.4936 -1.00871 18.4807 3.04155C14.35 7.21004 14.35 13.9947 18.4756 18.1632C19.1777 18.8725 20.1771 19.6641 21.3405 20.4608H5.125C2.30113 20.4608 0 22.7686 0 25.6007V33.3106C0 34.7292 1.148 35.8806 2.5625 35.8806H35.875V25.6007H46.125V35.8806H79.4375C80.852 35.8806 82 34.7292 82 33.3106V25.6007C82 22.7686 79.704 20.4608 76.875 20.4608ZM35.5726 20.2912C35.5726 20.2912 35.3574 20.4608 34.6245 20.4608C31.0831 20.4608 24.3232 16.7703 22.1144 14.5396C19.967 12.3705 19.967 8.83426 22.1144 6.66521C23.1547 5.61666 24.5334 5.04099 25.9991 5.04099C27.4597 5.04099 28.8384 5.61666 29.8787 6.66521C33.333 10.1501 36.7668 19.0524 35.5726 20.2912ZM46.4274 20.2912C46.4274 20.2963 46.6426 20.4608 47.3704 20.4608C50.9169 20.4608 57.6768 16.7703 59.8856 14.5396C62.0381 12.3705 62.0381 8.83426 59.8856 6.6652C57.7998 4.56297 54.1866 4.57325 52.1213 6.6652C48.667 10.1501 45.2332 19.0524 46.4274 20.2912ZM5.125 41.0205V71.8601C5.125 74.6973 7.42613 77 10.25 77H35.875V41.0205H5.125ZM46.125 77V41.0205H76.875V71.8601C76.875 74.6973 74.579 77 71.75 77H46.125Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h5 className="title text-uppercase">
                {props.translate("home.exp_info.gift_title")}
              </h5>
              <p className="content text-center not-selectable">
                {props.translate("home.exp_info.gift_desc")}
              </p>
              <Link
                to={global.experiences.links[props.lang]}
                className="show-all-button"
              >
                {props.translate("home.exp_info.gift_button")}
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L7 6.5L1 12"
                    stroke="#E75B2B"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
          <div className="col-12 col-md-6 m-0 p-0">
            <div className="info-holder self d-flex justify-content-center align-items-center flex-column">
              <div className="icon d-flex align-items-center">
                <svg
                  width="70"
                  height="75"
                  viewBox="0 0 70 75"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9.31425 0.232085C15.1922 1.70149 16.9538 9.6254 12.2456 13.3589C7.73734 16.9296 0.947412 14.2954 0.0887021 8.64023C-0.718172 3.32614 4.10888 -1.07442 9.31425 0.232085ZM12.0368 15.8927C13.9202 15.1086 16.1913 15.946 17.1125 17.7625L19.0599 21.6136L21.3934 21.347L16.6166 8.45313C16.301 7.60346 16.4244 6.65491 16.9415 5.91336C17.4602 5.17038 18.3096 4.72724 19.2156 4.72724H21.5247C22.4657 4.72724 23.2954 5.19777 23.7957 5.91496H65.905C68.1744 5.91496 70 7.7361 70 10.0049L69.9467 72.9733C69.9435 75.0091 68.8333 75.6119 67.4652 74.3193C66.0988 73.0264 64.4347 70.4227 63.7469 68.5042L59.0312 55.3224C58.4608 55.2188 57.9012 55.0164 57.3809 54.689L36.822 41.6884L18.6468 47.6038C18.5868 47.6227 18.5268 47.6341 18.4668 47.6456L18.4668 47.6456C18.4246 47.6537 18.3825 47.6618 18.3403 47.6724C17.4678 51.9389 17.5945 58.3874 23.8185 63.7153C24.2074 64.0471 24.2515 64.6288 23.9192 65.0156C23.7377 65.2288 23.4783 65.3369 23.2192 65.3369C23.0056 65.3369 22.792 65.264 22.6182 65.1146C15.99 59.4442 15.6544 52.507 16.5008 47.7563C15.1496 47.5431 13.9386 46.7422 13.2279 45.5073L13.2142 45.5134L13.144 45.364C13.1281 45.3336 13.11 45.3051 13.0918 45.2765L13.0918 45.2764C13.0699 45.2419 13.0479 45.2073 13.0296 45.1691L11.9864 42.9384C9.36624 42.0887 4.75259 40.0939 2.65861 36.1411C-0.353572 30.4555 2.65861 21.8478 2.65861 21.8478L2.68461 21.8965C2.77456 20.6114 3.55241 19.4313 4.84877 18.8893L12.0368 15.8927ZM45.666 20.4149C45.4006 18.4127 43.5783 16.3981 41.5954 15.9154L37.2867 14.868C36.9467 24.3908 31.1526 31.5929 27.9224 34.8865L36.0239 32.2492C37.3354 31.8214 38.76 32.0024 39.9283 32.7379L60.0328 45.4492L63.1121 38.5073C63.9402 36.645 64.1599 33.7626 63.6109 32.0695C63.0603 30.3762 61.0288 28.5262 59.0751 27.9369L49.6848 25.1062C47.731 24.5169 45.9314 22.4156 45.666 20.4149ZM25.5358 26.4417C26.3822 26.3442 27.1357 25.8662 27.581 25.1414C28.0263 24.4166 28.1148 23.5288 27.8189 22.7325L23.6782 11.5577L35.4492 14.4204C35.257 24.6467 28.2398 32.1228 25.6211 34.5607L21.7304 26.8758L25.5358 26.4417Z"
                    fill="white"
                  />
                </svg>
              </div>
              <h5 className="title text-uppercase">
                {props.translate("home.exp_info.self_title")}
              </h5>
              <p className="content text-center not-selectable">
                {props.translate("home.exp_info.self_desc")}
              </p>
              <Link
                to={global.corporateVoucher.links[props.lang] + "#contact"}
                className="show-all-button"
              >
                {props.translate("home.exp_info.self_button")}
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 1L7 6.5L1 12"
                    stroke="#E75B2B"
                    strokeWidth="1.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
